// extracted by mini-css-extract-plugin
export default {"page":"nZ-z","cartModal":"oZ-z","checkout":"pZ-z","placeholder":"qZ-z","account":"rZ-z"};